import { handlePostRequest } from "../hooks/api";

const googleApiKey = process.env.REACT_APP_GOOGLEMAP_API;
export async function googleMapHandler({
  latitude,
  longitude,
  radius,
  type,
  keyword,
  title
}) {
  try {
    const payload = {
      googleApiKey,
      latitude,
      longitude,
      type,
      keyword,
      title,
      radius,
      geohash: localStorage.getItem('geohash')||"9v6m"
    };
    const response = await handlePostRequest(
      "/location/retrieveGoogleMapsApiData",
      payload,
      undefined,
      false
    );
    if (response.status !== "success") {
      throw new Error("API request failed");
    }

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function googleMapImageHandler({ photo_reference }) {
  try {
    const payload = {
      apiKey: googleApiKey,
      photoReference: photo_reference
    };


    const response = await handlePostRequest(
      "/location/retrieveGoogleMapsApiImages",
      payload,
      undefined,
      false
    );

    if (response.status !== "success") {
      throw new Error("Image API request failed");
    }

    return response.imageUrl;
  } catch (error) {
    console.error("Client image fetch error:", error);
    throw error;
  }
}

// export async function googleMapHandler(requestBody) {
//   const endpoint = "/location/retrieveGoogleMapsApiData";
//   const response = await handlePostRequest(endpoint, requestBody, {}, false);
//   if (response?.error) {
//     throw new Error(response.error);
//   }
//   return response;
// }
